import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import * as Sentry from "@sentry/angular";
import {environment} from './environments/environment';
import {registerLicense} from '@syncfusion/ej2-base';
import {captureMobileLoginCode} from './app/shared/utils/mobile-login-code';
import {isExpectedHttpError, isUnsupportedFirebaseMessagingError} from './app/shared/services/validation-aware-error-handler';

// Scrub the one-time handoff code before Sentry/router initialization.
captureMobileLoginCode();

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXpfcXRWRGBcUUx/WERWYEo=');

// Sentry integration start
Sentry.init({
  dsn: "https://eeafad5b14683f2c9aa2180b66cf4bbd@o4511347780747264.ingest.de.sentry.io/4511347935805520",
  environment: environment.sentry.environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({levels: ["error"]})
  ],
  // Performance Monitoring
  tracesSampleRate: environment.sentry.traceSampleRate,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: environment.sentry.traceTargets,
  // Session Replay
  replaysSessionSampleRate: environment.sentry.replaySampleRate,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: (event, hint) =>
    isExpectedHttpError(hint.originalException) || isUnsupportedFirebaseMessagingError(hint.originalException) ? null : event,
  beforeSendLog: (log) => Object.values(log.attributes ?? {}).some(
    (value) => isExpectedHttpError(value) || isUnsupportedFirebaseMessagingError(value)
  ) ? null : log,
});
// Sentry integration end

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
